import { useMemo } from 'react';
import { useFragment } from '@apollo/client';

import { ProductDetailsMeta } from '@components/product/ProductDetailsMeta';

import {
  ProductDetailsMetaProductFragment,
  ProductDetailsMetaProductFragmentDoc,
  useProductDetailsMetaProductQuery,
} from './gql/graphql.v3.generated';
import { ProductDetailsMetaFragment, ProductDetailsMetaFragmentDoc } from './gql/graphql.v5.generated';

interface Props {
  productId: number,
}

export const ProductDetailsMetaContainer: React.FC<Props> = ({
  productId,
}) => {
  const { data: productMetaData, complete: productMetaDataCompleted } = useFragment<ProductDetailsMetaFragment>({
    fragment: ProductDetailsMetaFragmentDoc,
    from: {
      __typename: 'ProductType',
      id: productId,
    },
  });

  const { data: productData, complete: productDataCompleted } = useFragment<ProductDetailsMetaProductFragment>({
    fragment: ProductDetailsMetaProductFragmentDoc,
    from: {
      __typename: 'ProductDetails',
      id: productId,
    },
  });

  const { data } = useProductDetailsMetaProductQuery({
    variables: {
      productId,
      reviewsCount: 3,
    },
    context: {
      batch: true,
    },
  });

  const reviews = useMemo(
    () => (
      data?.productReviews?.edges.map(
        (edge) => edge!.node!,
      ) || []
    ),
    [data],
  );

  if (!productDataCompleted || !productMetaDataCompleted) {
    return null;
  }

  if (productData && productMetaData) {
    return (
      <ProductDetailsMeta
        metaTitle={productMetaData.metaTitle}
        metaDescription={productMetaData.metaDescription}
        product={productData}
        reviews={reviews}
      />
    );
  }

  return null;
};
